import type { components } from '@sportik/api-coach/schema';
import { useQuery } from '@tanstack/react-query';
import { browserTimeZone } from '@/lib/dates';
import { api } from '@/services/api-client';

type Roster = components['schemas']['Roster'];

/**
 * The one definition of the roster read: every state on one page, days counted
 * in the browser's zone. The loader, the page, and the sidebar share its key.
 */
export function rosterOptions() {
  return api.queryOptions('get', '/views/roster', {
    params: {
      query: {
        state: ['active', 'paused', 'stopped', 'archived'],
        limit: 200,
        timeZone: browserTimeZone(),
      },
    },
  });
}

/** Every variant of the roster read: what a write that changes a client's row invalidates. */
export function rosterKeyPrefix() {
  return rosterOptions().queryKey.slice(0, 2);
}

/** The roster screen's rows and counts. */
export function useRoster() {
  return useQuery(rosterOptions());
}

// Everyone still being coached: active and paused.
const toClientCount = (roster: Roster) =>
  roster.counts.active + roster.counts.paused;

/** How many clients the coach is coaching now. */
export function useClientCount() {
  return useQuery({ ...rosterOptions(), select: toClientCount });
}
